<div class="card-container">
  <div class="header" (click)="openItemClicked.emit($event)">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="body">
    <div style="width: 100%" (click)="openItemClicked.emit($event)"><ng-content select="[body]"></ng-content></div>
    <div class="more_ellipsis" *ngIf="menu" [matMenuTriggerFor]="menu">
      <eps-icon icon="ellipsis-v"></eps-icon>
    </div>
  </div>
</div>
